<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--left" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.42143 22.0424V17.2705H23.4446L23.4951 14.8726H8.42143V10.1126L0.00037384 16.0775L8.42143 22.0424Z" />
</svg>
</template>